export const regions = [
  {
    href: 'https://decodo.com',
    title: 'Global (EN)',
    locale: 'en',
  },
  {
    href: 'https://decodo.cn',
    title: 'China (中文)',
    locale: 'zh-cn',
  },
] as const;
